<template>
  <div id="home">
    <!--搜索-->
    <topSearchView v-if="bottomShow == ''" @topSearchParentReceive="topSearchParentReceiveFN"/>
    <!--底部内容-->
    <div class="bottomView" v-if="bottomShow == ''">
      <!--左侧的分类选择-->
      <div class="indexLeftBox" @click="goZYSearch">
        <!--答疑-->
        <div class="leftNewTypeBox" style="margin-top: 0">
          <div class="leftNewTypeTitle">
            <div class="leftNewTitleLeft">
              <span>答疑</span>
              <span class="leftNewTitleTotal">({{ dyList.count }})</span>
            </div>
            <div class="leftNewTitleRight">
              <img
                src="@/assets/blueTop.png"
                style="
                  width: 24px;
                  height: 24px;
                  cursor: pointer;
                  vertical-align: text-bottom;
                  transform: translateX(28px);
                "
                v-show="btn.dy"
                @click.stop="btn.dy = !btn.dy"
              />
              <img
                src="@/assets/blueBottom.png"
                style="
                  width: 24px;
                  height: 24px;
                  cursor: pointer;
                  vertical-align: text-bottom;
                  transform: translateX(28px);
                "
                v-show="!btn.dy"
                @click.stop="btn.dy = !btn.dy"
              />
            </div>
          </div>
          <div class="leftNewTypeContent" v-show="btn.dy">
            <div
              class="leftNewTypeContentList"
              v-for="(item, index) in dyList.childs"
              :key="index">
              <div class="leftNewTypeListLeft">
                <span>{{ item.name }}</span>
                <span class="leftNewTypeListTotal">({{ item.count }})</span>
              </div>
              <div class="leftNewTypeListRight">
                <div
                  class="leftNewTypeListRightBtn"
                  @click.stop="listJump(item.id)">
                  更多
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 法规标签树 -->
        <div class="treeBox" style="margin-top: 20px">
          <div class="boxTitle">
            <span>法规</span>
            <span class="typeTotal">({{ fgList.count }})</span>
            <img
              src="@/assets/blueTop.png"
              style="
                width: 24px;
                height: 24px;
                position: absolute;
                right: 20px;
                top: 26px;
                cursor: pointer;
              "
              v-show="btn.fg"
              @click.stop="btn.fg = !btn.fg"
            />
            <img
              src="@/assets/blueBottom.png"
              style="
                width: 24px;
                height: 24px;
                position: absolute;
                right: 20px;
                top: 26px;
                cursor: pointer;
              "
              v-show="!btn.fg"
              @click.stop="btn.fg = !btn.fg"
            />
          </div>
          <div class="treeTypeBox" v-show="btn.fg">
            <!-- 标签树 -->
            <div class="tree_container">
              <el-tree
                class="show-tree"
                ref="eltree"
                :data="fgList.childs"
                :props="defaultProps"
                :render-content="renderContent"
                :highlight-current="true"
                node-key="id"
                :default-expanded-keys="treeExpandData"
                :current-node-key="keyIda"
                @node-click="handleNodeClick">
                  <!-- highlight-current 高亮显示 不让背景消失  如果想取消选中也可以在某个事件上为false就可以随着点击事件取消高亮 -->
              </el-tree>
            </div>
          </div>
        </div>

        <!--解读-->
        <div class="leftNewTypeBox">
          <div class="leftNewTypeTitle">
            <div class="leftNewTitleLeft">
              <span>解读</span>
              <span class="leftNewTitleTotal">({{ jdList.count }})</span>
            </div>
            <div class="leftNewTitleRight">
              <img
                src="@/assets/blueTop.png"
                style="
                  width: 24px;
                  height: 24px;
                  cursor: pointer;
                  vertical-align: text-bottom;
                  transform: translateX(28px);
                "
                v-if="btn.jd"
                @click.stop="btn.jd = !btn.jd"
              />
              <img
                src="@/assets/blueBottom.png"
                style="
                  width: 24px;
                  height: 24px;
                  cursor: pointer;
                  vertical-align: text-bottom;
                  transform: translateX(28px);
                "
                v-else
                @click.stop="btn.jd = !btn.jd"
              />
            </div>
          </div>
          <div class="leftNewTypeContent" v-show="btn.jd">
            <div
              class="leftNewTypeContentList"
              v-for="(item, index) in jdList.childs"
              :key="index">
              <div class="leftNewTypeListLeft">
                <span>{{ item.name }}</span>
                <span class="leftNewTypeListTotal">({{ item.count }})</span>
              </div>
              <div class="leftNewTypeListRight">
                <div
                  class="leftNewTypeListRightBtn"
                  @click.stop="listJump(item.id)">
                  更多
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--专题-->
        <div class="leftNewTypeBox">
          <div class="leftNewTypeTitle">
            <div class="leftNewTitleLeft">
              <span>专题</span>
              <span class="leftNewTitleTotal">({{ ztList.count }})</span>
            </div>
            <div class="leftNewTitleRight">
              <img
                src="@/assets/blueTop.png"
                style="
                  width: 24px;
                  height: 24px;
                  cursor: pointer;
                  vertical-align: text-bottom;
                  transform: translateX(28px);
                "
                v-show="btn.zt"
                @click.stop="btn.zt = !btn.zt"
              />
              <img
                src="@/assets/blueBottom.png"
                style="
                  width: 24px;
                  height: 24px;
                  cursor: pointer;
                  vertical-align: text-bottom;
                  transform: translateX(28px);
                "
                v-show="!btn.zt"
                @click.stop="btn.zt = !btn.zt"
              />
            </div>
          </div>
          <div class="leftNewTypeContent" v-show="btn.zt">
            <div
              class="leftNewTypeContentList"
              v-for="(item, index) in ztList.childs"
              :key="index">
              <div class="leftNewTypeListLeft">
                <span v-if="item.name === '组合式税费'">组合式税费支持政策</span>
                <span v-else>{{ item.name }}</span>
                <span class="leftNewTypeListTotal">({{ item.count }})</span>
              </div>
              <div class="leftNewTypeListRight">
                <div
                  class="leftNewTypeListRightBtn"
                  @click.stop="listJump(item.id)">
                  更多
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--税率查询-->
        <div class="leftNewTypeBox">
          <div class="leftNewTypeTitle">
            <div class="leftNewTitleLeft">
              <span>税率查询</span>
              <span class="leftNewTitleTotal">({{ slcxList.count }})</span>
            </div>
            <div class="leftNewTitleRight">
              <img
                src="@/assets/blueTop.png"
                style="
                  width: 24px;
                  height: 24px;
                  cursor: pointer;
                  vertical-align: text-bottom;
                  transform: translateX(28px);
                "
                v-show="btn.slcx"
                @click.stop="btn.slcx = !btn.slcx"
              />
              <img
                src="@/assets/blueBottom.png"
                style="
                  width: 24px;
                  height: 24px;
                  cursor: pointer;
                  vertical-align: text-bottom;
                  transform: translateX(28px);
                "
                v-show="!btn.slcx"
                @click.stop="btn.slcx = !btn.slcx"
              />
            </div>
          </div>
          <div class="leftNewTypeContent" v-show="btn.slcx">
            <div
              class="leftNewTypeContentList"
              v-for="(item, index) in slcxList.childs"
              :key="index">
              <div class="leftNewTypeListLeft">
                <span>{{ item.name }}</span>
                <span class="leftNewTypeListTotal">({{ item.count }})</span>
              </div>
              <div class="leftNewTypeListRight">
                <div
                  class="leftNewTypeListRightBtn"
                  @click.stop="listJump(item, 'slcx')">
                  更多
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 涉税实务 -->
        <div class="treeBox" id="sheBox" style="margin-top: 20px">
          <div
            class="boxTitle"
            :id="categoryId == 21547 ? 'sheBlue' : ''"
            style="cursor: pointer"
            @click="getSheshui">
            涉税实务手册
            <span :id="categoryId == 21547 ? 'sheBlue' : ''"class="typeTotal">({{ ssswList.count }})</span>
            <img
              src="@/assets/blueTop.png"
              style="
                width: 24px;
                height: 24px;
                position: absolute;
                right: 20px;
                top: 26px;
                cursor: pointer;
              "
              v-show="btn.sssw && categoryId != 21547"
              @click.stop="btn.sssw = !btn.sssw"
            />
            <img
              src="@/assets/blueBottom.png"
              style="
                width: 24px;
                height: 24px;
                position: absolute;
                right: 20px;
                top: 26px;
                cursor: pointer;
              "
              v-show="!btn.sssw && categoryId != 21547"
              @click.stop="btn.sssw = !btn.sssw"
            />
            <img
              src="@/assets/top.png"
              style="
                width: 24px;
                height: 24px;
                position: absolute;
                right: 20px;
                top: 26px;
                cursor: pointer;
              "
              v-show="btn.sssw && categoryId == 21547"
              @click.stop="btn.sssw = !btn.sssw"
            />
            <img
              src="@/assets/bottom.png"
              style="
                width: 24px;
                height: 24px;
                position: absolute;
                right: 20px;
                top: 26px;
                cursor: pointer;
              "
              v-show="!btn.sssw && categoryId == 21547"
              @click.stop="btn.sssw = !btn.sssw"
            />
          </div>
          <div class="treeTypeBox" v-show="btn.sssw">
            <!-- 标签树 -->
            <div class="tree_container">
              <el-tree
                class="show-tree"
                ref="eltree"
                :data="ssswList.childs"
                :props="defaultPropsTwo"
                :render-content="renderContent"
                :highlight-current="true"
                node-key="id"
                :default-expanded-keys="treeExpandData"
                :current-node-key="keyIda"
                @node-click="handleNodeClick"
              >
                <!-- highlight-current 高亮显示 不让背景消失  如果想取消选中也可以在某个事件上为false就可以随着点击事件取消高亮 -->
              </el-tree>
            </div>
          </div>
        </div>

        <!--稽查案例-->
        <div class="leftNewTypeBox">
          <div class="leftNewTypeTitle">
            <div class="leftNewTitleLeft">
              <span>稽查案例</span>
              <span class="leftNewTitleTotal">({{ jcList.count }})</span>
            </div>
            <div class="leftNewTitleRight">
              <div class="leftNewTitleBtn" @click.stop="listJump(jcList.id)">
                更多
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--右侧-->
      <div class="cjkNewRight">
        <!--税务稽查ai问 新增-->
        <swjcwView />
      </div> 
    </div>
    <div class="bottomView" v-if="bottomShow != ''&&bottomShow!='loading'">
      <treeView :sendZsgObj="sendZsgObj" />
    </div>

  </div>
  
</template>
<script>

//引入组件
import ruleListView from '@/components/ruleList.vue'
import topSearchView from '@/components/topSearch.vue'

import swjcwView from '@/components/swjcwView/index.vue'


import treeView from '@/components/zsgView/treeView.vue'



//接口
import {
  tagTreeCache,
  dictionaryDataList,
  HomeLaw,
  keyLenovo,
  HomeAnalyzeKeyword,
  list,
  Cmsdetail,
  tal,
  cmsDataGetTagNames,
} from '@/api/api'

import addImg from '@/assets/images/03_add_12px_12px.png'
import subImg from '@/assets/images/02_sub_12px_12px.png'

export default {
    name:'',
    components:{
        ruleListView,
        topSearchView,
        swjcwView,
        treeView,
    },
    data(){
        return{
          //底部展示内容
          bottomShow:'',
          sendZsgObj:{},
            categoryId: '',
            // 答疑渲染列表
            dyList: [],
            // 解读渲染列表
            jdList: [],
            // 专题渲染列表
            ztList: [],
            // 税率查询渲染列表
            slcxList: [],
            // 涉税实务渲染列表
            ssswList: [],
            // 特约专家渲染列表
            jcList: [],
            // 法规对象
            fgList: {},
            //碎片全文 list
            spfgIdListStr: null,
            tags: [],
            //自己定义的用于接收tree树id的数组
            treeExpandData: [],
            keyIda: '',
            // 解决点击分屏导致tree不展开节点
            keyIdc: '',
            defaultProps: {
                children: 'tags',
                label: 'name',
                isLeaf: 'isLeaf', //isLeaf在tree组件里面算是判断有没有子集 相当于可以控制三角显示▶️
            },
            defaultPropsTwo: {
                children: 'childs',
                label: 'name',
                isLeaf: 'isLeaf', //isLeaf在tree组件里面算是判断有没有子集 相当于可以控制三角显示▶️
            },
            btn: {
                fg: true,
                sssw: true,
                tyzj: true,
                dy: true,
                jd: true,
                zt: true,
                slcx: true,
            },
            // 法规类型
            hang: [
              { id: 1, name: '国家税收法规', total: 0 },
              { id: 2, name: '地方税收政策', total: 0 },
              { id: 12, name: '中央部门法规', total: 0 },
              { id: 20, name: '地方部门法规', total: 0 },
            ],
            xiaolinum: {
              xxyx: '0',
              mqsx: '0',
              swsx: '0',
            },
        }
    },
    created(){
        //获取全文碎片 id
        this.getZSGsearchFG()
        /*//获取首页列表数据 常用业务手册
        this.tree()
        //税种业务手册
        this.tree1()
        //规费基金业务手册
        this.tree2()
        //行业涉税手册
        this.tree3()
        //企业全程涉税手册
        this.tree4()
        //税干常用手册
        this.tree5()
        //会计常用手册
        this.tree6()
        //税收优惠业务手册
        this.tree7()
        //进出口税收优惠手册
        this.tree8()*/
        this.HomeLaw()
    },
    mounted(){
        console.log(this.searchTypeList)
    },
    methods:{
        //搜索框 搜索按钮的点击 -- 子组件传递
        topSearchParentReceiveFN(data){
            console.log(data)
        },
        //进入专业版搜索
        goZYSearch(){
          let newObj = {
                searchType:0,
                inputValue:'',
                startPublicDate:'',
                endPublicDate:'',
                searchKeyName:'content'
            }
          this.$router.push({
              name:'searchZY',
              params:newObj
          })
        },

        // 获取当前数据
    HomeLaw(type) {
      this.loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      //
      let data = {
        withContent: false,
        content: '',
        articleNo: '',
        title: '',
      }
      if (this.startPublicDate || this.endPublicDate) {
        ;(data.startPublicDate = this.startPublicDate),
          (data.endPublicDate = this.endPublicDate)
      }
      console.log(this.tags)
      if (this.tags != false) {
        this.searchType = Number(this.searchType)
        let str = ''
        this.tags.forEach((element) => {
          if (element.type != 6) {
            str += element.name + ' '
          }
        })
        this.input1 = str
        switch (this.searchType) {
          case 1:
            data.content = this.input1
            break
          case 2:
            data.title = this.input1
            break
          case 3:
            data.articleNo = this.input1
            break
        }
      } else {
        this.input1 = ''
      }
      HomeLaw(data).then((res) => {
        console.log(res.data.data)
        for (let i = 0; i < res.data.data.length; i++) {
          if (res.data.data[i].id == 4013) {
            this.fgList = res.data.data[i]
          }
        }

        this.fgList.childs.forEach((element) => {
          console.log(element)
          // 转换成标签树识别字段进行渲染
          // console.log(element, "uuuuuuuuuu");
          if (
            element.tags &&
            element.tags.length == 0 &&
            element.childs != null
          ) {
            element.tags = element.childs
          } else if (!element.tags && element.childs != null) {
            element.tags = element.childs
          }
          if (element.tags && element.tags != false) {
            element.tags.forEach((ele) => {
              // if (ele.tags.length != 0 && ele.tags != null) {
              ele.tags = ele.children
              if (ele.code) {
                ele.type = 'fenlei'
              } else {
                ele.type = 'tree'
              }
              if (ele.tags != null) {
                ele.tags.forEach((el) => {
                  el.tags = el.children
                  if (el.code) {
                    el.type = 'fenlei'
                  } else {
                    el.type = 'tree'
                  }
                  if (el.tags != null) {
                    el.tags.map((it) => {
                      it.tags = it.children
                      if (it.code) {
                        it.type = 'fenlei'
                      } else {
                        it.type = 'tree'
                      }
                      if (it.tags != null) {
                        it.tags.map((ii) => {
                          ii.tags = ii.children
                          if (ii.code) {
                            ii.type = 'fenlei'
                          } else {
                            ii.type = 'tree'
                          }
                          if (ii.tags != null) {
                            ii.tags.map((ip) => {
                              ip.tags = ip.children
                              if (ip.code) {
                                ip.type = 'fenlei'
                              } else {
                                ip.type = 'tree'
                              }
                              if (ip.tags != null) {
                                ip.tags.map((ie) => {
                                  ie.tags = ie.children
                                  if (ie.code) {
                                    ie.type = 'fenlei'
                                  } else {
                                    ie.type = 'tree'
                                  }
                                })
                              }
                            })
                          }
                        })
                      }
                    })
                  }
                })
              }

              // }
            })
          }
        })

        this.treeCountFil(this.fgList)
        console.log(res.data.data, 'llll')
        res.data.data.map((it) => {
          if (it.id == 4024) {
            this.dyList = it
          } else if (it.id == 4013) {
          } else if (it.id == 4028) {
            this.jdList = it
          } else if (it.id == 4133) {
            this.ztList = it
          } else if (it.id == 5841) {
            this.slcxList = it
          } else if (it.id == 21547) {
            this.ssswList = it
          } else if (it.id == 32502) {
            this.jcList = it
          } else if (it.id == 22471) {
          }
        })
        // this.jcList = res.data.data[7]
        // this.dyList = res.data.data[0]
        // this.jdList = res.data.data[2]
        // this.ztList = res.data.data[3]
        // this.slcxList = res.data.data[4]
        // this.ssswList = res.data.data[5]

        // 递归处理标签树数据方法
        this.treeFilter(this.ssswList.childs)

        let count = 0
        if (this.ztList.childs) {
          this.ztList.childs.forEach((el) => {
            count += el.count
          })
        }
        console.log(this.ztList, 'ggggggggggggggggggggggggggggggg')

        this.ztList.count = count
        console.log(this.ztList)
        if (type && type == 'sheshui') {
          console.log('shehsui')
          this.searchTotal = this.ssswList.count
          this.$nextTick(() => {
            document.getElementById('sheBox').scrollIntoView()
          })
        } else {
          this.searchTotal =
            this.fgList.count +
            this.jcList.count +
            this.dyList.count +
            this.jdList.count +
            this.ztList.count +
            this.slcxList.count +
            this.ssswList.count
        }

        // if(this.categoryId){
        console.log(this.searchTotal, 'kkkkkkkkkkkkkkkkkkkkkkkkkkk')
        // }else{
        //   this.searchTotal = this.fgList.count+this.jcList.count+this.dyList.count+this.jdList.count+this.ztList.count;
        // }
        if (this.keyIda) {
          this.$nextTick(() => {
            this.$refs.eltree.setCurrentKey(this.keyIda)
          })
          this.fgList.childs.forEach((element) => {
            //
            if (element.id == this.keyIda) {
              this.searchTotal = element.count
            } else {
              if (element.tags) {
                element.tags.forEach((el) => {
                  if (el.id == this.keyIda) {
                    this.searchTotal = el.count
                  } else {
                    if (el.tags) {
                      el.tags.forEach((e) => {
                        if (e.id == this.keyIda) {
                          this.searchTotal = e.count
                        }
                      })
                    }
                  }
                })
              }
            }
          })
        }
        // this.searchType = 1;
        this.loading.close()
      })
    },
        getSheshui() {
          return
      //clg点击涉税实务列表变换
      this.sheShuitype = false
      this.HomeLaw('sheshui')
      if (this.tags.length > 0) {
        this.tags = this.tags.filter((it) => it.type != 6)
      }
      this.xlfwBol = false
      this.ids = ''
      this.searchBol = false
      this.aaa = false
      this.categoryId = 21547

      this.keyIda = ''
      let obj = {
        name: '涉税实务',
        id: 21547,
        type: 6,
      }
      this.tags.push(obj)
      let forData = []
      this.tags.forEach((it) => {
        if (!forData.some((e) => e.id == it.id)) forData.push(it)
      })

      this.tags = forData
      this.$forceUpdate()
      this.getlist()
    },
        // 修改标签树默认渲染
    renderContent: function (h, { node, data, store }) {
      // console.log(data);
      // console.log(node);
      // 标签树一级渲染样式
      // if(node.level !== 1 && node.data.count === 0){
      //
      //     const parent = node.parent;
      //     const children = parent.data.tags || parent.data;
      //     const index = children.findIndex(d => d.id === data.id);
      //     children.splice(index, 1);
      // }
      if (node.level === 1) {
        //
        if (node.expanded == false) {
          return (
            <div class="typeTitleBox" style="width:calc(100% - 20px)">
              <span class="title" style="font-size: 18px;color: #000;">
                {node.label}
              </span>
              <span
                class="typeTotal"
                style="font-size: 16px;color: #c22424;margin-left:5px;"
              >
                ({data.count})
              </span>
              <span
                class="open"
                style="width: 32px;height: 20px;margin: 11px 0;text-align: center;font-size: 14px;line-height: 20px;color: #fff;float: right;background: #718fae;border-radius: 4px;display: inline-block;cursor: pointer;"
              >
                展开
              </span>
            </div>
          )
        } else {
          return (
            <div class="typeTitleBox" style="width:calc(100% - 20px)">
              <span class="title" style="font-size: 18px;color: #000;">
                {node.label}
              </span>
              <span
                class="typeTotal"
                style="font-size: 16px;color: #c22424;margin-left:5px;"
              >
                ({data.count})
              </span>
              <span
                class="open"
                style="width: 32px;height: 20px;margin: 11px 0;text-align: center;font-size: 14px;line-height: 20px;color: #fff;float: right;background: #718fae;border-radius: 4px;display: inline-block;cursor: pointer;"
              >
                收起
              </span>
            </div>
          )
        }
      } else if (node.level !== 1 && data.tags) {
        // if(data.count == 0){
        //   //
        //   const parent = node.parent;
        //   const children = parent.data.tags || parent.data;
        //   const index = children.findIndex(d => d.id === data.id);
        //   children.splice(index, 1);
        // }else{
        if (node.expanded == false) {
          return (
            <div
              class="tOne"
              style="width:100%;padding-left:20px;line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;"
            >
              <img
                src={addImg}
                style="width:15px;height:15px;margin-right:6px"
              />
              <p style="display:inline-block;width: calc(100% - 20px);word-wrap: break-word;word-break: break-all;white-space: pre-wrap !important;vertical-align: middle;line-height:1em;">
                {node.label}
                <span
                  class="typeTotal"
                  style="font-size: 16px;color: #c22424;margin-left:5px;"
                >
                  ({data.count})
                </span>
              </p>
            </div>
          )
        } else {
          return (
            <div
              class="tOne"
              style="width:100%;padding-left:20px;line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;"
            >
              <img
                src={subImg}
                style="width:15px;height:15px;margin-right:6px"
              />
              <p style="display:inline-block;width: calc(100% - 20px);word-wrap: break-word;word-break: break-all;white-space: pre-wrap !important;vertical-align: middle;line-height:1em;">
                {node.label}
                <span
                  class="typeTotal"
                  style="font-size: 16px;color: #c22424;margin-left:5px;"
                >
                  ({data.count})
                </span>
              </p>
            </div>
          )
        }
        // }
      } else {
        // if(data.count == 0){
        //   // 清除tree节点
        //   const parent = node.parent;
        //   const children = parent.data.tags || parent.data;
        //   const index = children.findIndex(d => d.id === data.id);
        //   children.splice(index, 1);
        // }else{
        if (node.isCurrent) {
          return (
            <div
              class="tOne"
              style="width:100%;padding-left:20px;line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;"
            >
              <p style="display:inline-block;width: calc(100% - 20px);word-wrap: break-word;word-break: break-all;white-space: pre-wrap !important;vertical-align: middle;line-height:1em;">
                {node.label}
                <span
                  class="typeTotal"
                  style="font-size: 16px;color: #c22424;margin-left:5px;"
                >
                  ({data.count})
                </span>
              </p>
            </div>
          )
        } else {
          return (
            <div
              class="tOne"
              style="width:100%;padding-left:20px;line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;"
            >
              <p style="display:inline-block;width: calc(100% - 20px);word-wrap: break-word;word-break: break-all;white-space: pre-wrap !important;vertical-align: middle;line-height:1em;">
                {node.label}
                <span
                  class="typeTotal"
                  style="font-size: 16px;color: #c22424;margin-left:5px;"
                >
                  ({data.count})
                </span>
              </p>
            </div>
          )
        }
        // }
      }
    },
        // 点击标签树方法
    handleNodeClick(data, node) {
      this.searchBol = false
      console.log(data, 'datasssssssssssssssss')
      console.log(node, 'nodssssssssssssssse')

      if(data.parentId == '6558575'){
        let ttObj = {
          count:data.count,
          categoryId:data.id,
          name:data.name,
          isTags:true,
          pId:node.parent.data.id,
          pName:node.parent.data.name,
          tName:'法规'
        }
        // if(data.parentId == '6558575'){
          
        // }
        //let deCodeText = encodeURI(JSON.stringify(ttObj))
        //console.log(deCodeText)
        this.$router.push({
          name:'searchZY',
          query:ttObj
        })
      }
      
      


      this.aaa = false
      //
      this.keyIdc = data.id
      this.keyIdd = node.parent.data.id
      //
      this.xlIdone = 'xl'
      this.xlId = ['qwyx', 'bfyx', 'tdsjyx']
      if (data.attribute) {
        if (data.attribute.modelId == 'flk') {
          this.xl = [
            { id: 'xl', name: '全  部' },
            { id: 'qwyx', name: '全文有效' },
            { id: 'bfyx', name: '部分有效' },
            // { id: "tdsjyx", name: "特定时间有效" },
          ]
          // 明确失效法规
          this.xlone = [
            { id: 'xlone', name: '全  部' },
            { id: 'qwsx', name: '全文废止' },
            { id: 'bfsx', name: '部分失效' },
            // { id: "tdsjsx", name: "特定时间失效" },
          ]
        } else {
          this.xl = [
            { id: 'xl', name: '全  部' },
            { id: 'qwyx', name: '全文有效' },
            { id: 'bfyx', name: '部分有效' },
            { id: 'tdsjyx', name: '特定时间有效' },
          ]
          // 明确失效法规
          this.xlone = [
            { id: 'xlone', name: '全  部' },
            { id: 'qwsx', name: '全文废止' },
            { id: 'bfsx', name: '部分失效' },
            { id: 'tdsjsx', name: '特定时间失效' },
          ]
        }
      } else {
        if (node.parent.data.id == '4018') {
          this.xl = [
            { id: 'xl', name: '全  部' },
            { id: 'qwyx', name: '全文有效' },
            { id: 'bfyx', name: '部分有效' },
            // { id: "tdsjyx", name: "特定时间有效" },
          ]
          // 明确失效法规
          this.xlone = [
            { id: 'xlone', name: '全  部' },
            { id: 'qwsx', name: '全文废止' },
            { id: 'bfsx', name: '部分失效' },
            // { id: "tdsjsx", name: "特定时间失效" },
          ]
        } else {
          this.xl = [
            { id: 'xl', name: '全  部' },
            { id: 'qwyx', name: '全文有效' },
            { id: 'bfyx', name: '部分有效' },
            { id: 'tdsjyx', name: '特定时间有效' },
          ]
          // 明确失效法规
          this.xlone = [
            { id: 'xlone', name: '全  部' },
            { id: 'qwsx', name: '全文废止' },
            { id: 'bfsx', name: '部分失效' },
            { id: 'tdsjsx', name: '特定时间失效' },
          ]
        }
      }

      this.searchTotal = data.count
      if (node.level == 1) {
        this.categoryId = data.id
        // 新需求除模型为法规的以外都不显示效力范围
        if (data.attribute && data.attribute.extend.modelId == 'fagui') {
          this.xlfwBol = true
        } else {
          this.xlfwBol = false
        }
        this.tagTreeIdC = ''
        this.treeIDD = data.id
      } else {
        if (node.level == 2) {
          if (data.type == 'tree') {
            this.categoryId = node.parent.data.id
            this.tagTreeIdC = data.id
            // 新需求除模型为法规的以外都不显示效力范围
            if (
              node.parent.data.attribute &&
              node.parent.data.attribute.extend.modelId == 'fagui'
            ) {
              this.xlfwBol = true
            } else {
              this.xlfwBol = false
            }
          } else {
            this.categoryId = data.id
            this.tagTreeIdC = ''
            // 新需求除模型为法规的以外都不显示效力范围
            if (data.attribute && data.attribute.extend.modelId == 'fagui') {
              this.xlfwBol = true
            } else {
              this.xlfwBol = false
            }
          }
        } else {
          console.log(data, 'levellevel')
          if (data.type == 'tree') {
            this.categoryId = this.treeIDD
            this.tagTreeIdC = data.id
            // 新需求除模型为法规的以外都不显示效力范围
            if (
              node.parent.parent.data.attribute &&
              node.parent.parent.data.attribute.extend.modelId == 'fagui'
            ) {
              this.xlfwBol = true
            } else {
              this.xlfwBol = false
            }
            // 判断涉税实务下办税实务操作下 纳税期限（21578） 和 申报流程（21579）分类特殊处理
          } else if (
            node.parent.data.id == 21579 ||
            node.parent.data.id == 21578
          ) {
            this.categoryId = node.parent.data.id
            this.tagTreeIdC = data.id
            // 新需求除模型为法规的以外都不显示效力范围
            if (
              node.parent.data.attribute &&
              node.parent.data.attribute.extend.modelId == 'fagui'
            ) {
              this.xlfwBol = true
            } else {
              this.xlfwBol = false
            }
          } else {
            this.categoryId = data.id
            this.tagTreeIdC = ''
            // 新需求除模型为法规的以外都不显示效力范围
            if (data.attribute && data.attribute.extend.modelId == 'fagui') {
              this.xlfwBol = true
            } else {
              this.xlfwBol = false
            }
          }
        }
      }
      if (data.id == 4019) {
        this.dictionaryValues.type = this.hangId
        this.ids = 1
      } else if (node.level == 2 && node.parent.data.id == 4019) {
        this.dictionaryValues.type = this.hangId
        this.ids = 1
      } else if (node.level == 3 && node.parent.parent.data.id == 4019) {
        this.dictionaryValues.type = this.hangId
        this.ids = 1
      } else {
        this.dictionaryValues = {}
        this.ids = ''
      }
      this.aaaFun(node)
      this.name = data.name
      this.list = []
      this.pageIndex = 1
      // console.log(this.fgList);
      // console.log(this.tagTreeIdC);
      // debugger
      let idList = {
        name: '',
        id: '',
        childs: [],
      }
      idList.name = this.fgList.name
      idList.id = this.fgList.id
      this.fgList.childs.forEach((element) => {
        idList.childs.push(element.id)
      })
      this.getlist()
      // console.log(idList);
      // this.treeExpandData = [];
      // console.log(this.treeExpandData);
    },
        //获取碎片全文规则
    getZSGsearchFG() {
      let send_data = {
        dictionaryId: 'zsgSearchFG',
      }
      dictionaryDataList(send_data)
        .then((res) => {
          console.log(res)
          let tRes = res.data.list
          let rArr = []
          for (let a = 0; a < tRes.length; a++) {
            rArr.push(tRes[a].id.value)
          }
          this.spfgIdListStr = rArr
          this.spfgIdListStr = this.spfgIdListStr.join(',')
          this.$forceUpdate()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取法规标签树数据方法
    tree() {
      let data = {
        rootId: '6557331',
        typeIds: '',
        level: 1,
      }
      tagTreeCache(data).then((res) => {
        // console.log(res);
        this.treeData = res.data.data.children
        // this.numberFun(this.treeData)
        // this.getEquipmentList();
        // this.dataSearch();
      })
    },
    //税种业务手册
    tree1() {
      let data = {
        rootId: '6558575',
        typeIds: '',
        level: 1,
      }
      tagTreeCache(data).then((res) => {
        this.treeData1 = res.data.data.children
      })
    },
    //规费基金业务手册
    tree2() {
      let data = {
        rootId: '6561976',
        typeIds: '',
        level: 2,
      }
      tagTreeCache(data).then((res) => {
        this.treeData2 = res.data.data.children
      })
    },
    //行业涉税手册
    tree3() {
      let data = {
        rootId: '6562083',
        typeIds: '',
        level: 1,
      }
      tagTreeCache(data).then((res) => {
        let tRes = res.data.data.children
        //手动减去
        let passStr = '6627422,6627346,6627318,6627159'
        for (let a = tRes.length - 1; a >= 0; a--) {
          if (passStr.indexOf(tRes[a].id) != -1) {
            tRes.splice(a, 1)
          }
        }
        this.treeData3 = tRes
      })
    },
    //企业全程涉税手册
    tree4() {
      let data = {
        rootId: '6563043',
        typeIds: '',
        level: 1,
      }
      tagTreeCache(data).then((res) => {
        this.treeData4 = res.data.data.children
      })
    },
    //税干常用手册
    tree5() {
      let data = {
        rootId: '6563911',
        typeIds: '',
        level: 1,
      }
      tagTreeCache(data).then((res) => {
        this.treeData5 = res.data.data.children
      })
    },
    //会计常用手册
    tree6() {
      let data = {
        rootId: '6564398',
        typeIds: '',
        level: 1,
      }
      tagTreeCache(data).then((res) => {
        let tRes = res.data.data.children
        //手动减去
        let passStr = '6627581,6637285'
        for (let a = tRes.length - 1; a >= 0; a--) {
          if (passStr.indexOf(tRes[a].id) != -1) {
            tRes.splice(a, 1)
          }
        }
        this.treeData6 = tRes
      })
    },
    //税收优惠业务手册
    tree7() {
      let data = {
        rootId: '6564533',
        typeIds: '',
        level: 1,
      }
      tagTreeCache(data).then((res) => {
        this.treeData7 = res.data.data.children
      })
    },
    //进出口税收优惠手册
    tree8() {
      let data = {
        rootId: '6565603',
        typeIds: '',
        level: 1,
      }
      tagTreeCache(data).then((res) => {
        this.treeData8 = res.data.data.children
      })
    },
    // 获取关键词
    dictionaryDataList() {
      let data = {
        dictionaryId: 'zhzsk_fgzspt_keyword',
      }
      dictionaryDataList(data).then((res) => {
        // console.log(res);
        this.keyWordList = res.data.list
      })
    },
    treeFilter(v) {
      v.forEach((el) => {
        if (el.tags && el.childs == undefined) {
          el.childs = el.tags
        } else if (el.childs && el.childs.length > 0) {
          this.treeFilter(el.childs)
        }
      })
      console.log(this.ssswList)
    },
    treeCountFil(v) {
      // console.log(v, "fffffffffffffffff");
      //debugger;
      if (v.tags && v.tags.length != 0) {
        let list = []
        for (let i = 0; i < v.tags.length; i++) {
          const element = v.tags[i]
          if (element.count !== 0) {
            // element.type = "tree";
            list.push(element)
            if (element.tags != null) {
              element.children.map((it) => {
                // it.type = "tree";
              })
              element.tags = this.treeCountFil2(element.tags)
            }
          }
        }
        v.tags = list
        // console.log(v.tags,'7777777777');
      } else if (v.childs != null && v.tags && v.tags.length == 0) {
        console.log(v, 'hhhhhhhhhh')
        v.childs.forEach((element) => {
          // element.type = "fenlei";
          this.treeCountFil(element)
        })
      } else {
      }
    },
    treeCountFil2(v) {
      // console.log(v, "qqqqqqqqqqqqqqqqqqqqqqqqq");
      let list = []
      for (let i = 0; i < v.length; i++) {
        const element = v[i]
        // element.type = "tree";
        if (element.count !== 0) {
          // element.children.map((it) => {
          //   it.type = "tree";
          // });
          list.push(element)
        }
      }
      return list
    },
    // 更多列表跳转
    listJump(v, type) {
      console.log(type, 'oooooooooooooooooooooooo')
      if (type == 'slcx') {
        console.log(v, 'kkkkkkkkkkkkk')
        let obj = {
          contentId: v.contents ? v.contents[0].id : '',
          keyWord: this.input,
          searchType: this.searchType,
        }
        let Detail = this.$router.resolve({
          path: '/content',
          query: obj,
        })
        window.open(Detail.href, '_blank')
      } else {
        let obj = {
          id: v,
          keyWord: '',
          searchType: '',
          startPublicDate: '',
          endPublicDate: '',
        }
        if (this.input) {
          obj.keyWord = this.input
          obj.searchType = 1
        } else if (this.inputTitle) {
          obj.keyWord = this.inputTitle
          obj.searchType = 2
        } else if (this.inputArticleNo) {
          obj.keyWord = this.inputArticleNo
          obj.searchType = 3
        } else if (this.startPublicDate || this.endPublicDate) {
          obj.startPublicDate = this.startPublicDate
          obj.endPublicDate = this.endPublicDate
          obj.searchType = 4
        }
        let Detail = this.$router.resolve({
          path: '/list',
          query: obj,
        })
        window.open(Detail.href, '_blank')
      }
    },
    aaaFun(v, k) {
      let obj = {}
      if (k) {
        obj = k
      }
      //
      if (v.level == 1) {
        if (v.expanded) {
          obj.name = v.data.name
          obj.id = v.data.id
          obj.type = 6
          let bol = false
          this.tags.forEach((element) => {
            if (element.type == 6) {
              bol = true
              element.id = v.data.id
              element.name = v.data.name
              element.parentId = ''
            }
          })
          if (bol == false) {
            this.tags.push(obj)
          }
        }
      } else {
        if (v.parent.level == 1) {
          obj.type = 6
          obj.name = v.parent.data.name + '-' + v.data.name
          obj.id = v.data.id
          obj.parentId = v.parent.data.id
          let bol = false
          this.tags.forEach((element) => {
            if (element.type == 6) {
              bol = true
              element.id = v.data.id
              element.name = v.parent.data.name + '-' + v.data.name
              element.parentId = v.parent.data.id
            }
          })
          if (bol == false) {
            this.tags.push(obj)
          }
        } else if (v.parent.level == 2) {
          obj.type = 6
          obj.name =
            v.parent.parent.data.name +
            '-' +
            v.parent.data.name +
            '-' +
            v.data.name
          obj.id = v.data.id
          obj.parentId = v.parent.parent.data.id
          let bol = false
          this.tags.forEach((element) => {
            if (element.type == 6) {
              bol = true
              element.id = v.data.id
              element.name =
                v.parent.parent.data.name +
                '-' +
                v.parent.data.name +
                '-' +
                v.data.name
              element.parentId = v.parent.parent.data.id
            }
          })
          if (bol == false) {
            this.tags.push(obj)
          }
        }
      }
    },
    // 数据列表
    getlist() {
      //
      this.loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      // this.dictionaryValues.state = this.xlId;
      let data = {
        articleNo: '',
        categoryId: this.categoryId,
        content: '',
        page: this.pageIndex,
        size: this.pageSize,
        states: this.xlId,
        dictionaryValues: this.dictionaryValues,
        tagIds: [],
        title: '',
      }
      let obj = {
        articleNo: '',
        categoryId: this.categoryId,
        content: '',
        page: this.pageIndex,
        size: this.pageSize,
        states: this.xlId,
        dictionaryValues: {},
        tagIds: [],
        title: '',
        dictionaryValuesKeys: ['type_20', 'type_1', 'type_2', 'type_12'],
      }
      let addnum = {
        articleNo: '',
        categoryId: this.categoryId,
        content: '',
        page: 1,
        size: 1,
        states: ['qwyx', 'bfyx', 'tdsjyx'],
        dictionaryValues: {},
        tagIds: [],
        title: '',
        dictionaryValuesKeys: ['type_20', 'type_1', 'type_2', 'type_12'],
      }
      let addnumer = {
        articleNo: '',
        categoryId: this.categoryId,
        content: '',
        page: 1,
        size: 1,
        states: ['qwsx', 'bfsx', 'tdsjsx'],
        dictionaryValues: {},
        tagIds: [],
        title: '',
        dictionaryValuesKeys: ['type_20', 'type_1', 'type_2', 'type_12'],
      }
      let addnumsan = {
        articleNo: '',
        categoryId: this.categoryId,
        content: '',
        page: 1,
        size: 1,
        states: ['swsx'],
        dictionaryValues: {},
        tagIds: [],
        title: '',
        dictionaryValuesKeys: ['type_20', 'type_1', 'type_2', 'type_12'],
      }
      let numone = {
        articleNo: '',
        categoryId: this.categoryId,
        content: '',
        page: 1,
        size: 1,
        states: ['qwyx', 'bfyx', 'tdsjyx'],
        dictionaryValues: {},
        tagIds: [],
        title: '',
      }
      let numer = {
        articleNo: '',
        categoryId: this.categoryId,
        content: '',
        page: 1,
        size: 1,
        states: ['qwsx', 'bfsx', 'tdsjsx'],
        dictionaryValues: {},
        tagIds: [],
        title: '',
      }
      let numsan = {
        articleNo: '',
        categoryId: this.categoryId,
        content: '',
        page: 1,
        size: 1,
        states: ['swsx'],
        dictionaryValues: {},
        tagIds: [],
        title: '',
      }
      //
      // 判断是否为中税官跳转而来 如果是，categoryId值是空的 所以给其赋值
      if (this.categoryId) {
      } else {
        data.categoryId = this.$route.query.id
        obj.categoryId = this.$route.query.id
        numone.categoryId = this.$route.query.id
        numer.categoryId = this.$route.query.id
        numsan.categoryId = this.$route.query.id
        addnum.categoryId = this.$route.query.id
        addnumer.categoryId = this.$route.query.id
        addnumsan.categoryId = this.$route.query.id
      }
      if (this.input1) {
        switch (this.searchType) {
          case 1:
            data.content = this.input1
            obj.content = this.input1
            numone.content = this.input1
            numer.content = this.input1
            numsan.content = this.input1
            addnum.content = this.input1
            addnumer.content = this.input1
            addnumsan.content = this.input1
            break
          case 2:
            data.title = this.input1
            obj.title = this.input1
            numone.title = this.input1
            numer.title = this.input1
            numsan.title = this.input1
            addnum.title = this.input1
            addnumer.title = this.input1
            addnumsan.title = this.input1
            break
          case 3:
            data.articleNo = this.input1
            obj.articleNo = this.input1
            numone.articleNo = this.input1
            numer.articleNo = this.input1
            numsan.articleNo = this.input1
            addnum.articleNo = this.input1
            addnumer.articleNo = this.input1
            addnumsan.articleNo = this.input1
            break
        }
      } else if (this.startPublicDate || this.endPublicDate) {
        // 判定是否时间查询
        data.startPublicDate = this.startPublicDate
        obj.startPublicDate = this.startPublicDate
        numone.startPublicDate = this.startPublicDate
        numer.startPublicDate = this.startPublicDate
        numsan.startPublicDate = this.startPublicDate
        addnum.startPublicDate = this.startPublicDate
        addnumer.startPublicDate = this.startPublicDate
        addnumsan.startPublicDate = this.startPublicDate

        data.endPublicDate = this.endPublicDate
        obj.endPublicDate = this.endPublicDate
        numone.endPublicDate = this.endPublicDate
        numer.endPublicDate = this.endPublicDate
        numsan.endPublicDate = this.endPublicDate
        addnum.endPublicDate = this.endPublicDate
        addnumer.endPublicDate = this.endPublicDate
        addnumsan.endPublicDate = this.endPublicDate
      }
      if (this.tagTreeIdC) {
        data.tagIds = [this.tagTreeIdC]
        obj.tagIds = [this.tagTreeIdC]
        numone.tagIds = [this.tagTreeIdC]
        numer.tagIds = [this.tagTreeIdC]
        numsan.tagIds = [this.tagTreeIdC]
        addnum.tagIds = [this.tagTreeIdC]
        addnumer.tagIds = [this.tagTreeIdC]
        addnumsan.tagIds = [this.tagTreeIdC]
      }
      // let data = {
      //   articleNo: this.searchType == 3 ? this.input1 : "",
      //   categoryId: this.categoryId,
      //   content: this.searchType == 1 ? this.input1 : "",
      //   page: this.pageIndex,
      //   size: this.pageSize,
      //   states: this.xlId,
      //   dictionaryValues: this.dictionaryValues,
      //   tagIds: this.tagTreeIdC?[this.tagTreeIdC]:[],
      //   title: this.searchType == 2 ? this.input1 : "",
      // };

      let xxyx = ''
      let mqsx = ''
      let swsx = ''
      console.log(this.categoryId, 'llllllll')
      if (this.categoryId != 4019) {
        console.log(numone, '数据1ssss')
        console.log(numer, '数据2sssss')
        console.log(numsan, '数据3')
        list(numone).then((res) => {
          console.log(res, 'kkkkk')
          this.$forceUpdate()
          xxyx = res.data.data.count
        })
        list(numer).then((res) => {
          console.log(res, 'ssssss')
          this.$forceUpdate()
          mqsx = res.data.data.count
        })
        list(numsan).then((res) => {
          console.log(res, 'xxxxx')
          this.$forceUpdate()
          swsx = res.data.data.count
        })
      } else {
        this.$forceUpdate()
        tal(addnum).then((res) => {
          xxyx =
            res.data.data.type_1 +
            res.data.data.type_2 +
            res.data.data.type_12 +
            res.data.data.type_20
          // console.log(22222222);
        })
        tal(addnumer).then((res) => {
          mqsx =
            res.data.data.type_1 +
            res.data.data.type_2 +
            res.data.data.type_12 +
            res.data.data.type_20
          // console.log(333333333);
        })
        tal(addnumsan).then((res) => {
          swsx =
            res.data.data.type_1 +
            res.data.data.type_2 +
            res.data.data.type_12 +
            res.data.data.type_20
          // console.log(444444444);
        })
      }
      list(data).then((res) => {
        this.$forceUpdate()
        // console.log(res, "jjjjjjjj");
        if (res.data.data.contents) {
          this.list = res.data.data.contents
          this.totaltol = res.data.data.count
          // console.log(this.xlId);

          this.list.map((ii) => {
            ii.publishDate = ii.publishDate.slice(0, 10)
          })
        } else {
          this.list = res.data.data.contents
          this.totaltol = res.data.data.count
        }
        setTimeout(() => {
          // 需求再次变更 点击效力范围显示数量改为当前范围数量
          // debugger
          if (
            this.xlId[0] == 'qwyx' ||
            this.xlId[0] == 'bfyx' ||
            this.xlId[0] == 'tdsjyx'
          ) {
            xxyx = res.data.data.count
          } else if (
            this.xlId[0] == 'qwsx' ||
            this.xlId[0] == 'bfsx' ||
            this.xlId[0] == 'tdsjsx'
          ) {
            mqsx = res.data.data.count
          } else {
            swsx = res.data.data.count
          }
          console.log(xxyx, mqsx, swsx, 'qqqqqqqqqqqqqqq')
          this.$forceUpdate()
          this.xiaolinum.xxyx = xxyx
          this.xiaolinum.mqsx = mqsx
          this.xiaolinum.swsx = swsx
          this.loading.close()
        }, 500)
        this.loading.close()
      })

      tal(obj).then((res) => {
        // console.log(res, "resresrsresres");
        this.hang[0].total = res.data.data.type_1
        this.hang[1].total = res.data.data.type_2
        this.hang[2].total = res.data.data.type_12
        this.hang[3].total = res.data.data.type_20
      })
    },

  }
}
</script>
<style scoped lang="scss">

@import '@/assets/css/home.scss';




</style>